import React from 'react';
import { useApp } from './context/AppContext';
import LoginScreen from './components/Login/LoginScreen';
import AppShell from './components/Shell/AppShell';

export default function App() {
  const { currentUser } = useApp();
  return currentUser ? <AppShell /> : <LoginScreen />;
}
